export default __webpack_public_path__ + "static/media/crusharmor1.5aa91b2e.png";